/**
 * Termos de Servico e Politica de Privacidade do Cabal Next -- TEXTO GENERICO (dono, 2026-10-10: "termos generico que
 * vou pegar, mas vai fazendo isso"), no modelo do "Termos de Servico.txt" que o dono mandou. Trocar aqui pelo
 * definitivo: o modal (LegalModal) so' le estes dois objetos.
 */

export type LegalDoc = {
  title: string;
  intro?: string;
  sections: { heading: string; items: string[] }[];
};

export const TERMS: LegalDoc = {
  title: 'Termos de Serviço',
  intro:
    'Estes Termos e Condições de Serviço valem entre a equipe do Cabal Next (doravante "a Equipe") e os usuários do ' +
    'jogo, do site e dos demais serviços do Cabal Next (doravante "os Usuários"), independentemente de qualquer ' +
    'pagamento. Eles entram em vigor quando o Usuário aceita estes termos e conclui o cadastro.',
  sections: [
    {
      heading: '1. Conta Cabal Next',
      items: [
        'A conta Cabal Next (ID e senha) permite ao Usuário entrar no jogo, no site e nos demais serviços do Cabal Next.',
        'As formas e condições para criar e cancelar a conta são as definidas e divulgadas pela Equipe.',
        'O Usuário deve informar somente dados verdadeiros e concorda que os dados definidos pela Equipe como importantes (como o e-mail de cadastro) não podem ser alterados livremente.',
      ],
    },
    {
      heading: '2. Regras de uso',
      items: [
        'O Usuário concorda em cumprir as regras, os regulamentos e a etiqueta definidos e divulgados pela Equipe.',
        'O Usuário concorda em não usar nomes, anúncios ou ações que sugiram se passar pela Equipe, nem praticar atos que violem a legislação brasileira, a moral ou os direitos de terceiros.',
        'Todas as informações da conta, incluindo os itens do jogo nela contidos, pertencem à Equipe. O Usuário recebe apenas o direito de usar a conta e os itens durante o período do serviço. A Equipe pode alterar, recuperar, suspender ou cancelar esse uso a qualquer momento.',
        'O Usuário é responsável pela segurança do seu ID e da sua senha. Se as informações da conta forem transferidas, vendidas, trocadas ou emprestadas, o Usuário responde por qualquer dano que resulte disso, e a Equipe não se responsabiliza.',
        'Em caso de uso de programas de trapaça, fraude intencional, disputas ou qualquer ação que cause dano à Equipe ou a outros Usuários, a Equipe pode suspender a conta de forma temporária ou permanente, sem aviso prévio e sem necessidade de consentimento, e o Usuário concorda em não reivindicar indenização.',
        'A Equipe pode tomar medidas legais contra quem reproduzir, modificar, exibir, disponibilizar ou distribuir o jogo ou parte dele sem autorização prévia por escrito, ou praticar qualquer ação que cause dano à Equipe, direta ou indiretamente.',
      ],
    },
    {
      heading: '3. Período de testes (beta)',
      items: [
        'Durante o beta, o jogo e os serviços podem passar por manutenções, instabilidades e mudanças sem aviso prévio.',
        'A data de início e de término do beta e eventuais recompensas de participação são definidas e divulgadas pela Equipe nos canais oficiais.',
      ],
    },
    {
      heading: '4. Reembolsos',
      items: [
        'Todas as compras de bens ou serviços são finais. A Equipe não possui política de reembolso ou devolução, salvo o que a lei exigir. A Equipe pode suspender ou cancelar a conta em caso de pedido de reembolso ou estorno, total ou parcial, que indique risco de fraude, uso indevido do sistema de reembolso ou violação destes Termos.',
      ],
    },
    {
      heading: '5. Privacidade',
      items: [
        'O tratamento dos dados pessoais do Usuário segue a Política de Privacidade do Cabal Next, que faz parte destes Termos.',
      ],
    },
    {
      heading: '6. Limitação de responsabilidade',
      items: [
        'A Equipe não se responsabiliza por danos, perdas ou despesas, diretos ou indiretos, específicos, incidentais ou consequenciais, decorrentes de erros, omissões, interrupções, defeitos, falhas, vírus de computador ou ataques de terceiros, mesmo que a Equipe tenha sido avisada da possibilidade desses danos.',
      ],
    },
    {
      heading: '7. Alterações',
      items: [
        'A Equipe pode alterar estes Termos a qualquer momento. A versão atualizada é publicada no site e passa a valer a partir da publicação.',
      ],
    },
  ],
};

export const PRIVACY: LegalDoc = {
  title: 'Política de Privacidade',
  intro:
    'Esta Política explica quais dados pessoais o Cabal Next coleta, para que usa e quais são os seus direitos, de ' +
    'acordo com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).',
  sections: [
    {
      heading: '1. Dados que coletamos',
      items: [
        'Dados de cadastro: ID, nome, e-mail e senha (guardada de forma protegida, nunca em texto puro).',
        'Dados de acesso: endereço IP, data e hora de entrada no site e no jogo e informações do dispositivo.',
        'Dados de uso do jogo: personagens, itens, progresso e registros de atividade dentro do jogo.',
      ],
    },
    {
      heading: '2. Para que usamos',
      items: [
        'Criar e manter a sua conta e permitir o acesso ao jogo e ao site.',
        'Enviar códigos de confirmação e avisos importantes, como a data de início do beta.',
        'Proteger o jogo e os jogadores: prevenção de fraude, trapaça e acesso indevido.',
        'Atender o suporte e melhorar o jogo e os serviços.',
      ],
    },
    {
      heading: '3. Compartilhamento',
      items: [
        'Não vendemos os seus dados pessoais.',
        'Compartilhamos apenas o necessário com prestadores de serviço que fazem o Cabal Next funcionar (por exemplo, envio de e-mail, verificação anti-robô e, quando houver recarga, os provedores de pagamento), e quando exigido por lei ou ordem judicial.',
      ],
    },
    {
      heading: '4. Armazenamento e segurança',
      items: [
        'Os dados ficam guardados enquanto a conta existir ou pelo tempo exigido por lei, com medidas de segurança para evitar acesso, perda ou alteração indevidos.',
      ],
    },
    {
      heading: '5. Seus direitos',
      items: [
        'Você pode pedir a confirmação e o acesso aos seus dados, a correção de dados incompletos ou errados, a exclusão da conta e dos dados (respeitados os prazos legais) e a revogação do consentimento, pelos canais oficiais do Cabal Next.',
      ],
    },
    {
      heading: '6. Cookies e armazenamento no navegador',
      items: [
        'O site guarda no seu navegador apenas o necessário para funcionar, como a sessão de acesso e preferências.',
      ],
    },
    {
      heading: '7. Alterações',
      items: [
        'Esta Política pode ser atualizada a qualquer momento. A versão atualizada é publicada no site e passa a valer a partir da publicação.',
      ],
    },
  ],
};
